module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_c('audio', {
    attrs: {
      "id": "gtyQaVoiceNotify",
      "src": "https://awp-assets.meituan.net/hfe/fep/gtynotice.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "jiujingQaVoiceNotify",
      "src": "https://awp-assets.meituan.net/hfe/fep/jingjiunotice.mp3"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e354c12","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/voiceNotification.vue
// module id = 925
// module chunks = 0